module.exports = __webpack_public_path__ + "assets/img/MVGX-CNC-2022.28170cfc.jpeg";